import { render, staticRenderFns } from "./LocationSvg.vue?vue&type=template&id=fdc542b6"
import script from "./LocationSvg.vue?vue&type=script&lang=js"
export * from "./LocationSvg.vue?vue&type=script&lang=js"
import style0 from "./LocationSvg.vue?vue&type=style&index=0&id=fdc542b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports